import { initCardsSlider } from "../modules/cards-slider.js";
jQuery(($) => initCardsSlider($));
